<template>
    <div class="flex wrap center">
        <MetaBox :meta="{
            key: 'token',
            type: 'text',
            name: 'توکن دسترسی',
            style: JSON.stringify({ 'width': '75%' })
        }" :vm="value" @onchange="(obj) => value = obj.value"></MetaBox>
    </div>
    <div v-if="span > 0" class="status flex wrap center vcenter">
        <span>{{ status }}</span>
    </div>
    <div class="option flex wrap center vcenter">
        <Option v-if="span <= 0" :color="'blue'" :icon="'fe-send'" :name="'ارسال توکن'"
            @onclick="sending ? () => { } : onclick('send')">
        </Option>
        <Option :color="'green'" :icon="'fe-key'" :name="'تطبیق توکن'" @onclick="onclick('check')"></Option>
    </div>
</template>

<script>
/* eslint-disable */
import { defineAsyncComponent } from 'vue'

import Tabs from '../Form/Inputs/Tabs.vue'
import Checkbox from '../Form/Inputs/Checkbox.vue'
import Option from '../Form/Option.vue'

export default {
    name: 'Verify',
    props: ['data'],
    inject: ['base'],
    components: {
        Tabs,
        MetaBox: defineAsyncComponent(() => import('../Form/Inputs/MetaBox.vue')),
        Checkbox,
        Option
    },
    created() {
    },
    data() {
        return {
            value: '',
            status: '',
            span: 0,
            sending: false
        }
    },
    methods: {
        timer(action = 'refresh', extra = 60) {
            if (action === 'start') {
                this.span = extra
                this.timer('status')
            } else if (action === 'status') {
                this.status = `${this.span} ثانیه تا ارسال مجدد کد تائید`
                this.timer()
            } else if (action === 'refresh') {
                if (this.span > 0) {
                    setTimeout(() => {
                        this.span -= 1
                        this.timer('status')
                    }, 1000)
                } else
                    this.status = 'کد تائید را دریافت نکردید؟'
            }
        },
        onclick(action) {
            if (action === 'send') {
                this.sending = true
                this.base.API().get(`Authentication/OTP/Token?guid=${this.$route.params.id}`, (response) => {
                    if (this.base.Util().success(response)) {
                        this.span = response.data?.span && response.data?.span > 0
                            ? response.data?.span : 180
                        this.timer('status')
                    } else {
                        this.base.Notification().error({
                            code: response.data.errorCode,
                            referr: 'Token',
                            text: response.data.message
                        })
                        this.sending = false
                    }
                }, (error) => {
                    this.sending = false
                })
            } else if (action === 'check') {
                if (this.base.Util().validate(this.value))
                    this.base.API().get(`Authentication/OTP/Validation?guid=${this.$route.params.id}&token=${this.value}`, (response) => {
                        if (this.base.Util().success(response))
                            this.$emit('onresult', true)
                        else
                            this.base.Notification().error({
                                code: response.data.errorCode,
                                referr: 'Token',
                                text: response.data.message
                            })
                    }, (error) => {
                    })
                else
                    this.base.Notification().error({
                        code: 1000,
                        referr: 'Token',
                        text: 'توکن دسترسی'
                    })
            }
        }
    }
}
</script>

<style scoped src="../../assets/css/components/dialogs/verify.css"></style>
<style scoped src="../../assets/css/components/dialogs/verify_dark.css"></style>